import React, { useMemo } from 'react';
import { GeoJsonLayer } from '@deck.gl/layers';
import { DeckGLLayer } from '@leverege/ui-google-maps-elements';
import { Selection, SelectionResolver } from '@leverege/ui-redux';
import Model from "./GroupClusterModel.js";
import Util from "./Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function GroupClusterRenderer(props) {
  const {
    centers,
    items,
    interaction,
    selected,
    rollover,
    model,
    attribute,
    backupRenderer: BackupRenderer
  } = props;
  const layerIds = useMemo(() => {
    return [`${attribute.id}-group-cluster`, `${attribute.id}-points`];
  }, [attribute.id]);
  const isRolloverable = model ? Model.getRolloverable(model) : true;
  const isSelectable = model ? Model.getSelectable(model) : true;
  interaction[isSelectable ? 'addSelectableId' : 'removeSelectableId'](layerIds);
  interaction[isRolloverable ? 'addRolloverId' : 'removeRolloverId'](layerIds);
  const layers = [];
  if (centers.length > 0) {
    layers.push(/*#__PURE__*/_jsx(DeckGLLayer, {
      id: layerIds[0],
      append: true,
      layer: new GeoJsonLayer({
        id: layerIds[0],
        data: centers,
        stroked: true,
        filled: true,
        pickable: isSelectable,
        pointRadiusScale: 1,
        pointRadiusMinPixels: 16,
        pointRadiusUnits: 'meters',
        pointType: 'circle+text',
        getPointRadius: d => {
          return d.properties.maxSize / 2;
        },
        getFillColor: d => {
          const ref = {
            id: d.properties.id,
            type: d.properties.dataType,
            ref: d.properties.dataRef
          };
          const isRollover = Selection.isSelected(rollover, d.properties.id) || SelectionResolver.isChildOf(ref, rollover?.items?.[0]);
          const color = isRollover && d.properties.rolloverFillColor ? d.properties.rolloverFillColor : d.properties.fillColor;
          const opacity = isRollover && d.properties.rolloverOpacity ? d.properties.rolloverOpacity : d.properties.opacity;
          return Util.getColorAndOpacity(color, opacity);
        },
        getLineWidth: 2,
        getLineWidthMinPixels: 1,
        lineWidthMinPixels: 1,
        lineWidthUnits: 'pixels',
        getLineColor: d => {
          const ref = {
            id: d.properties.id,
            type: d.properties.dataType,
            ref: d.properties.dataRef
          };
          const isRollover = Selection.isSelected(rollover, d.properties.id) || SelectionResolver.isChildOf(ref, rollover?.items?.[0]);
          const color = isRollover && d.properties.rolloverLineColor ? d.properties.rolloverLineColor : d.properties.lineColor;
          const opacity = isRollover && d.properties.rolloverOpacity ? d.properties.rolloverOpacity : d.properties.opacity;
          return Util.getColorAndOpacity(color, opacity);
        },
        updateTriggers: {
          getFillColor: [selected, rollover],
          getLineColor: [selected, rollover]
        },
        getText: d => `${d.properties.count}`,
        getTextSize: d => {
          return d.properties.labelSize;
        },
        textSizeUnits: 'pixels',
        getTextColor: d => {
          const ref = {
            id: d.properties.id,
            type: d.properties.dataType,
            ref: d.properties.dataRef
          };
          const isRollover = Selection.isSelected(rollover, d.properties.id) || SelectionResolver.isChildOf(ref, rollover?.items?.[0]);
          const opacity = isRollover && d.properties.rolloverOpacity ? d.properties.rolloverOpacity : d.properties.opacity;
          return Util.getColorAndOpacity(d.properties.labelColor, opacity);
        },
        textOutlineWidth: 2,
        textOutlineColor: [35, 167, 141, 255],
        textFontSettings: {
          sdf: true
        },
        textFontFamily: 'Inter, sans-serif',
        textFontWeight: 'bold'
      })
    }, layerIds[0]));
  }
  if (items.length > 0) {
    layers.push(/*#__PURE__*/_jsx(BackupRenderer, {
      ...props,
      model: props.model?.backupRenderer
    }, `${layerIds[1]}`));
  }
  return layers;
}